import { CSSProperties, forwardRef, useState } from 'react';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

import CheckboxInputView from './CheckboxInputView';
import CheckboxInputWithControllerView from './CheckboxInputWithControllerView';

interface IProps {
  control?: Control<FieldValues, object>;
  errors?: FieldErrors;
  value?: string;
  name?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  id?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  title?: string;
  style?: CSSProperties;
  isLoading?: boolean;
}

const CheckboxInput = forwardRef(function CheckboxInput(props: IProps, ref) {
  const { control, defaultChecked, checked, onChange } = props;

  const [isChecked, setIsChecked] = useState(defaultChecked || checked);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);

    onChange && onChange(event);
  };

  if (control) {
    return <CheckboxInputWithControllerView {...props} />;
  }

  return <CheckboxInputView {...{ ...props, onChange: handleOnChange, isChecked, ref }} />;
});

export default CheckboxInput;
